/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.cta-block-container {
  @apply grid grid-cols-1 gap-32px justify-center w-full mx-auto rounded-xl items-stretch font-poppins;
}

.layout-3 {
  @apply md:grid-cols-3
}

.layout-4 {
  @apply grid-cols-2 md:grid-cols-4
}

.cta-block-card {
  @apply flex mx-auto flex-col items-center  justify-center text-center max-w-[700px] rounded-xl py-44px px-24px w-full;
}

.cta-block-super-title {
  @apply fs-1 font-medium  mt-16px;
}

.cta-block-title {
  @apply fs-3 font-bold mt-16px;
}

.button-container {
  @apply flex flex-wrap gap-12px mt-32px w-full justify-center;
}

/* Animations */
@keyframes fade-in {
  0% {
    opacity: 0.4;
  }
  100% {
    opacity: 0;

  }
}

.overlay1, .overlay2, .overlay3, .overlay4{
  @apply absolute bg-white w-full h-full top-0 left-0 z-20 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: .5s;
}

.cta-block-section.animate .overlay1 {
  animation-name: fade-in;
  animation-delay: 0s;
}

.cta-block-section.animate .overlay2 {
  animation-name: fade-in;
  animation-delay: .15s;
}

.cta-block-section.animate .overlay3 {
  animation-name: fade-in;
  animation-delay: .30s;
}

.cta-block-section.animate .overlay4 {
  animation-name: fade-in;
  animation-delay: .45s;
}